import { faqs } from '@/mocks/home';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="section-container">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-10">常见问题</h2>
        <div className="max-w-3xl flex flex-col gap-4">
          {faqs.map((faq) => (
            <div
              key={faq.id}
              className="p-5 md:p-6 rounded-lg bg-background-100 border border-background-200/70"
            >
              <h3 className="text-base font-bold font-heading text-foreground-900 mb-2">
                {faq.question}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}